<template>
    <div>
        <div class="form-single">
            <div class="title">服务名称</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.title}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">分类名称</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.catName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">买家商户名称</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.buyerName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">买家机构名称</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.buyerShopName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">评价人公司</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.userComName}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">评价人</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.userName}}</label>
            </div>
        </div>
        <!--<div class="form-single">-->
        <!--<div class="title">服务评分</div>-->
        <!--<div class="content">-->
        <!--<el-rate v-model="orderServcEvalInfo.servcScore" disabled></el-rate>-->
        <!--</div>-->
        <!--</div>-->
        <div class="form-single">
            <div class="title">态度评价</div>
            <div class="content">
                <el-rate v-model="orderServcEvalInfo.attitudeScore" disabled></el-rate>
            </div>
        </div>
        <div class="form-single">
            <div class="title">技能评价</div>
            <div class="content">
                <el-rate v-model="orderServcEvalInfo.skillsScore" disabled></el-rate>
            </div>
        </div>
        <div class="form-single">
            <div class="title">质量评价</div>
            <div class="content">
                <el-rate v-model="orderServcEvalInfo.qualityScore" disabled></el-rate>
            </div>
        </div>
        <div class="form-single">
            <div class="title">工程师平均评价</div>
            <div class="content">
                <el-rate v-model="orderServcEvalInfo.avgScore" disabled></el-rate>
            </div>
        </div>
        <div class="form-single">
            <div class="title">评论内容</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.comment}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">提交时间</div>
            <div class="content">
                <label class="mr20">{{orderServcEvalInfo.submitTime}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">标签</div>
            <div class="content">
                <ul class="enum-list clearfix">
                    <li class="enum-item" v-for="orderServcEvalTagInfo in orderServcEvalInfo.orderServcEvalTagList">{{orderServcEvalTagInfo.name}}<i></i>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 附件信息 -->
        <div class="form-single">
            <div class="title">附件</div>
            <div class="content">
                <div class="file-area clearfix">
                    <div class="mr15 inline-block" v-for="(orderServcEvalFileInfo, index) in orderServcEvalInfo.orderServcEvalFileList">
                        <div class="file-item show-usage image deletable viewable downloadable editable">
                            <div class="file-content">
                                <div class="usage ellipsis-1">{{orderServcEvalFileInfo.fileName}}</div>
                                <img :src="orderServcEvalFileInfo.fileBrowseUrl"/>
                                <div class="operation-group">
                                    <i class="icon iconfont icon-chakan view" @click="viewImage(orderServcEvalFileInfo.fileBrowseUrl)"></i>
                                </div>
                                <div class="operation-group">
                                    <i class="icon iconfont icon-xiazai download" @click="downloadFile(orderServcEvalFileInfo.fileUuid);"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-servc-eval-info',
        desc: '服务评价详情',
        props: ["evalId"],
        data: function () {
            return {
                orderServcEvalInfo: {},
            }
        },
        created: function () {
            //
            this.getOrderServcEvalInfo();
        },
        methods: {
            viewImage: function (fileBrowseUrl) {

                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            downloadFile: function (fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            },
            getOrderServcEvalInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.evalId;
                let theLoading = MsgBox.loading();
                servcDelivApi.getOrderServcEvalInfo(self.evalId, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let orderServcEvalInfo = result.data;
                        let totalScore = orderServcEvalInfo.totalScore;
                        orderServcEvalInfo.avgScore = Math.round(totalScore / 3);
                        self.orderServcEvalInfo = orderServcEvalInfo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcEvalInfo.vue